import { getProductTotals } from 'artisn/products';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const useProductCard = (product, config = {}) => {
  const { amount, decimals } = config;
  const { prices, available, priceCategory } = product;
  const { NORMAL, POINTS } = prices;
  const productTotals = getProductTotals(product, amount);
  const sanitizedProductTotals = Object.entries(productTotals).reduce(
    (acc, field) => {
      const [key, value] = field;
      if (typeof value === "string" || value === null) {
        return __spreadProps(__spreadValues({}, acc), { [key]: value });
      }
      return __spreadProps(__spreadValues({}, acc), { [key]: +value.toFixed(decimals) });
    },
    {}
  );
  const totals = __spreadProps(__spreadValues({}, sanitizedProductTotals), {
    symbol: NORMAL.symbol,
    unitPoints: +(POINTS == null ? void 0 : POINTS.netPrice.toFixed(decimals)),
    points: +((POINTS == null ? void 0 : POINTS.netPrice) * productTotals.amount).toFixed(decimals),
    priceCategory
  });
  return { totals, available };
};

export { useProductCard };
//# sourceMappingURL=bundle.esm2.js.map
